import {createFetchAllSlice} from "../genericCrudSlice";
import {getExpensesGroupByCategoryApi} from "../../api/entities/expenses";

export const fetchExpensesGroupByCategorySlice = createFetchAllSlice('expensesGroupByCategory', getExpensesGroupByCategoryApi);
export const {fetchAllEntities: fetchExpensesGroupByCategory} = fetchExpensesGroupByCategorySlice;
export default fetchExpensesGroupByCategorySlice.reducer;
